import TextField from '@mui/material/TextField';
import React, { CSSProperties, useEffect } from 'react';
import { BoxInput } from './TextField.style';
import MenuItem from '@mui/material/MenuItem';
import InputMask from 'react-input-mask';
import { Select, FormControl, FormHelperText } from '@mui/material';

type TInputProps = {
  label: string;
  onChange: (value: any) => void;
  error?: boolean;
  helperText?: string;
  value: string | string[];
  type: string;
  nome: string;
  selected?: boolean;
  disabled?: boolean;
  multiple?: boolean;
  defaultValueText?: string;
  dados?: string[];
  mask?: string;
  style?: CSSProperties;
  maxLength?: number;
};

const TextInputField: React.FC<TInputProps> = ({
  label = '',
  onChange,
  error,
  helperText,
  value,
  type,
  nome,
  selected = false,
  disabled = false,
  defaultValueText,
  multiple = false,
  dados,
  mask,
  style,
}) => {
  const textFieldRef = React.useRef(null);

  useEffect(() => {
    const handleWheel = (e) => e.preventDefault();

    if (textFieldRef.current) {
      textFieldRef?.current?.addEventListener('wheel', handleWheel);
    }
    return () => {
      textFieldRef?.current?.removeEventListener('wheel', handleWheel);
    };
  }, []);

  // Verifica se o valor é um array quando o Select é múltiplo
  const selectValue = multiple ? (Array.isArray(value) ? value : []) : value;

  return (
    <>
      {!selected ? (
        <BoxInput style={style}>
          {label}
          {mask ? (
            <InputMask mask={mask} value={value} onChange={onChange} maskChar={null}>
              {(inputProps) => (
                <TextField
                  {...inputProps}
                  select={selected}
                  type={type}
                  name={nome}
                  error={error}
                  helperText={helperText}
                  inputRef={textFieldRef}
                />
              )}
            </InputMask>
          ) : (
            <TextField
              select={selected}
              disabled={disabled}
              type={type}
              name={nome}
              value={value}
              error={error}
              helperText={helperText}
              onChange={onChange}
              ref={textFieldRef}
            />
          )}
        </BoxInput>
      ) : (
        <BoxInput style={style}>
          {label}
          {multiple ? (
            <FormControl error={error}>
              <Select
                multiple
                labelId="demo-multiple-checkbox-label"
                type={type}
                name={nome}
                defaultValue={['*']}
                value={selectValue} // Utiliza o valor selecionado com base na condição
                disabled={disabled}
                onChange={onChange}
              >
                <MenuItem value={['*']} disabled>
                  {defaultValueText}
                </MenuItem>
                {dados &&
                  dados.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
              </Select>
              {helperText && <FormHelperText>{helperText}</FormHelperText>}
            </FormControl>
          ) : (
            <FormControl error={error}>
              <Select
                labelId="demo-multiple-checkbox-label"
                type={type}
                name={nome}
                defaultValue={'*'}
                value={value}
                disabled={disabled}
                onChange={onChange}
              >
                <MenuItem value={'*'} disabled>
                  {defaultValueText}
                </MenuItem>
                {dados &&
                  dados.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
              </Select>
              {helperText && <FormHelperText>{helperText}</FormHelperText>}
            </FormControl>
          )}
        </BoxInput>
      )}
    </>
  );
};

export default TextInputField;
